import script from "./CaptainReview.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptainReview.vue?vue&type=script&setup=true&lang=js"

import "./CaptainReview.vue?vue&type=style&index=0&id=31eaacca&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31eaacca"]])

export default __exports__